import * as React from 'react';
import LongTermDebtCore from '../AfrCore/LongTermDebtCore';

const LongTermDebt = (props: any) => {

    return (
        <React.Fragment>
            <LongTermDebtCore userRole="ENTITY_USER" />
        </React.Fragment>
    );
}

export default LongTermDebt;